/* Split media/carousel lifecycle. Sources are mounted once and native loop reuses them. */
(function () {
  'use strict';
  if (window.chvCarousel && window.chvCarousel.splitMedia) return;
  var instances = new Map();
  function init(root) {
    if (!root || instances.has(root)) return;
    var slides = Array.from(root.querySelectorAll('[data-chv-carousel-slide]'));
    if (!slides.length) return;
    var mq = matchMedia('(max-width: 749.98px)');
    var motion = matchMedia('(prefers-reduced-motion: reduce)');
    var index = 0, paused = motion.matches, focused = false, inView = false, timer;
    var disposed = false;
    var cleanups = [], frameCallbacks = new Map();
    var pause = root.querySelector('[data-chv-carousel-pause]');
    function on(target, event, handler) { target.addEventListener(event, handler); cleanups.push(function () { target.removeEventListener(event, handler); }); }
    function visible() { return !!root.getClientRects().length && getComputedStyle(root).visibility !== 'hidden'; }
    function activeLayer() { return slides[index].querySelector('[data-chv-layer="' + (mq.matches ? 'mobile' : 'desktop') + '"]'); }
    function stop() { clearTimeout(timer); timer = null; root.querySelectorAll('video').forEach(function (v) { v.pause(); }); }
    function video() { var layer = activeLayer(); return layer && layer.querySelector('video'); }
    function update() {
      if (disposed) return;
      stop();
      var layer = activeLayer();
      if (layer) root.style.setProperty('--chv-cm-col-ar', layer.dataset.ratio);
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active); slide.inert = !active; slide.setAttribute('aria-hidden', String(!active));
        if (root.dataset.transition === 'slide') slide.style.transform = 'translateX(' + ((i-index)*100) + '%)';
      });
      root.querySelectorAll('[data-chv-carousel-dot]').forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); dot.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      var count = root.querySelector('[data-chv-carousel-current]'); if (count) count.textContent = index + 1;
      var hasVideo = layer && !!layer.querySelector('video, template[data-chv-device]');
      var rotate = slides.length > 1 && root.dataset.autoplay !== 'off';
      if (pause) { pause.hidden = !hasVideo && !rotate; pause.classList.toggle('is-paused', paused); pause.setAttribute('aria-pressed', String(paused)); pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel); }
      var wrap = slides[index].querySelector('.chv-cm-panel__text-wrap');
      var content = slides[index].querySelector('.chv-cm-panel__text');
      if (wrap && content) {
        var spacing = getComputedStyle(wrap);
        root.style.minHeight = Math.ceil(content.getBoundingClientRect().height + parseFloat(spacing.paddingTop) + parseFloat(spacing.paddingBottom)) + 'px';
      }
      root.classList.toggle('chv-cm-col--has-motion', !!(pause && !pause.hidden));
      if (pause && !pause.hidden) {
        var text = slides[index].querySelector('.chv-cm-panel__text');
        var bottom = text ? text.getBoundingClientRect().bottom - root.getBoundingClientRect().top : 0;
        var controlY = Math.max(root.clientHeight + 12, bottom + 12);
        root.style.setProperty('--chv-cm-pause-y', controlY + 'px');
        root.style.setProperty('--chv-cm-control-space', (controlY - root.clientHeight + 56) + 'px');
      } else root.style.setProperty('--chv-cm-control-space', '0px');
      if (!visible()) return;
      var deferred = slides[index].querySelector('template[data-chv-visual-template]');
      if (deferred) { deferred.replaceWith(deferred.content.cloneNode(true)); }
      if (!inView || document.hidden || paused || focused) return;
      var template = layer && layer.querySelector('template[data-chv-device]');
      if (template) {
        var fragment = template.content.cloneNode(true);
        var v = fragment.querySelector('video');
        layer.appendChild(fragment); template.remove();
        v.muted = true;
        on(v, 'playing', function () {
          var poster = slides.find(function (s) { return s.contains(v); }).querySelector('[data-poster]');
          function presented() { frameCallbacks.delete(v); if (!v.paused && poster) poster.classList.add('chv-cm-poster-loaded'); }
          if (v.requestVideoFrameCallback) frameCallbacks.set(v, v.requestVideoFrameCallback(presented));
          else if (v.readyState >= 2) requestAnimationFrame(presented);
        });
        var ownerSlide = slides[index];
        on(v, 'error', function () { var poster = ownerSlide.querySelector('[data-poster]'); if (poster) poster.classList.remove('chv-cm-poster-loaded'); });
        on(v, 'ended', function () { if (rotate && !paused && !focused) go(index+1); });
      }
      var activeVideo = video();
      var poster = slides[index].querySelector('[data-poster]');
      if (poster) poster.classList.toggle('chv-cm-poster-loaded', !!(activeVideo && activeVideo.readyState >= 2 && !activeVideo.paused));
      if (activeVideo) { activeVideo.loop = !rotate; activeVideo.play().catch(function () {}); }
      if (rotate) timer = setTimeout(function () { go(index+1); }, activeVideo ? ((isFinite(activeVideo.duration) && activeVideo.duration > 0 ? activeVideo.duration : 60)*1000+3000) : (parseFloat(root.dataset.speed)||6)*1000);
    }
    function go(i) { if (slides[index].contains(document.activeElement)) document.activeElement.blur(); index=(i+slides.length)%slides.length; update(); }
    var prev=root.querySelector('[data-chv-carousel-prev]'), next=root.querySelector('[data-chv-carousel-next]');
    if(prev) on(prev,'click',function(){go(index-1);}); if(next) on(next,'click',function(){go(index+1);});
    root.querySelectorAll('[data-chv-carousel-dot]').forEach(function(dot,i){on(dot,'click',function(){go(i);});});
    if(pause) on(pause,'click',function(){paused=!paused; focused=false; update();});
    on(root,'focusin',function(e){ if(e.target===pause)return; focused=true; stop(); });
    on(root,'focusout',function(){setTimeout(function(){if(!root.contains(document.activeElement)){focused=false;update();}},0);});
    on(window,'resize',update);
    on(mq,'change',function(){slides.forEach(function(s){var p=s.querySelector('[data-poster]');if(p)p.classList.remove('chv-cm-poster-loaded');});update();});
    on(motion,'change',function(){paused=motion.matches;update();}); on(document,'visibilitychange',update);
    var observer = new IntersectionObserver(function(entries){inView=entries[0].isIntersecting;update();}); observer.observe(root);
    var mutation = new MutationObserver(function(){update();}); mutation.observe(root.closest('.chv-cm-section'),{attributes:true,attributeFilter:['class','style']});
    instances.set(root, function(){disposed=true;stop();observer.disconnect();mutation.disconnect();cleanups.forEach(function(f){f();});frameCallbacks.forEach(function(id,v){v.cancelVideoFrameCallback(id);});instances.delete(root);});
    if (document.fonts) document.fonts.ready.then(update);
    update();
  }
  function scan(scope){scope.querySelectorAll('.chv-cm-col').forEach(init);}
  window.chvCarousel={init:init,splitMedia:true};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){scan(document);},{once:true}); else scan(document);
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
  document.addEventListener('shopify:section:unload',function(e){instances.forEach(function(destroy,root){if(e.target.contains(root))destroy();});});
}());
